import { useEffect, useState } from 'react'
import { ReadOnlyStore, UseStoreValueHook } from './types'

export const useStoreValue: UseStoreValueHook = <Value>(
    store: ReadOnlyStore<Value>
): Value => {
    const [s, setS] = useState(store.value())

    useEffect(() => {
        const sub = store.changes().subscribe(x => {
            setS(x)
        })

        return () => {
            sub.unsubscribe()
        }
    }, [])

    return s
}
